import React from 'react'

const BlogJumbotron = () => {
    return (
        <div className="jumbotron p-3 p-md-5 text-white rounded bg-dark">
            <div className="col-md-6 px-0">
                <h1 className="display-4 font-italic">Join with us </h1>
                <p className="lead my-3">
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                </p>
                <p>
                    <button type="button" className="btn btn-success">Subscribe</button>
                </p>
            </div>
        </div>
    )
}

export default BlogJumbotron
